export default "__VITE_ASSET__a248d0ff__"